// src/components/Eventos/EventsHeats/components/LapSplitCard.jsx
import React from 'react';
import { Box, Typography, Card, useTheme, useMediaQuery } from '@mui/material';
import { getFontSize } from '../utils/eventHelpers';

const LapSplitCard = ({ 
  lapNumber, 
  splitTime, 
  cumulativeTime, 
  position, 
  positionChange,
  isActive = false,
  distance = null // Nueva prop para la distancia real
}) => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('sm'));
  const isSm = useMediaQuery(theme.breakpoints.down('md'));
  const isMd = useMediaQuery(theme.breakpoints.down('lg'));

  // Si se proporciona la distancia real, usarla; sino calcular como antes (fallback)
  const displayDistance = distance !== null ? distance : (lapNumber * 400);

  const getPositionChangeDisplay = () => {
    if (!positionChange || positionChange.val === 0) {
      return {
        text: '0',
        color: theme.palette.text.secondary
      };
    }
    
    if (positionChange.dir === 'up') {
      return {
        text: `+${positionChange.val}`,
        color: theme.palette.success.main
      };
    } else {
      return {
        text: `-${positionChange.val}`,
        color: theme.palette.error.main
      };
    }
  };

  const positionChangeDisplay = getPositionChangeDisplay();

  return (
    <Card
      sx={{
        position: 'relative',
        minHeight: isXs ? 90 : 110,
        backgroundColor: isActive ? '#e3f2fd' : '#ffffff',
        border: isActive ? `2px solid ${theme.palette.primary.main}` : '1px solid #e0e0e0',
        borderRadius: 2,
        overflow: 'hidden',
        transition: 'all 0.3s ease-in-out',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: theme.shadows[4],
        }
      }}
    >
      {/* Sección superior - Distancia */}
      <Box
        sx={{
          backgroundColor: isActive ? theme.palette.primary.main : '#f5f5f5',
          color: isActive ? 'white' : theme.palette.text.primary,
          py: 1,
          px: 2,
          textAlign: 'center',
          borderBottom: `1px solid ${theme.palette.divider}`,
        }}
      >
        <Typography
          sx={{
            fontSize: getFontSize(14, 1, isXs, isSm, isMd),
            fontWeight: 'bold',
            lineHeight: 1
          }}
        >
          {displayDistance}m
        </Typography>
      </Box>

      {/* Posición en esquina superior izquierda */}
      <Box
        sx={{
          position: 'absolute',
          top: isXs ? 45 : 50,
          left: 8,
          zIndex: 2
        }}
      >
        <Typography
          sx={{
            fontSize: getFontSize(14, 1, isXs, isSm, isMd),
            fontWeight: 'bold',
            color: theme.palette.primary.main, // Color azul para el texto
            backgroundColor: 'transparent', // Fondo transparente
            px: 0.5,
            py: 0.2,
            borderRadius: 0.5,
            minWidth: 20,
            textAlign: 'center',
            border: `1px solid ${theme.palette.primary.main}` // Borde azul sutil
          }}
        >
          {position || '-'}
        </Typography>
      </Box>

      {/* Cambio de posición en esquina superior derecha */}
      <Box
        sx={{
          position: 'absolute',
          top: isXs ? 45 : 50,
          right: 8,
          zIndex: 2
        }}
      >
        <Typography
          sx={{
            fontSize: getFontSize(12, 1, isXs, isSm, isMd),
            fontWeight: 'bold',
            color: positionChangeDisplay.color, // Color según dirección
            backgroundColor: 'transparent', // Fondo transparente
            px: 0.5,
            py: 0.2,
            borderRadius: 0.5,
            minWidth: 20,
            textAlign: 'center',
            border: `1px solid ${positionChangeDisplay.color}` // Borde del color correspondiente
          }}
        >
          {positionChangeDisplay.text}
        </Typography>
      </Box>

      {/* Sección inferior - Datos */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: isXs ? 58 : 68,
          px: 2,
          flexDirection: 'column'
        }}
      >
        {/* Tiempo acumulado */}
        <Typography
          sx={{
            fontSize: getFontSize(20, 1, isXs, isSm, isMd),
            fontWeight: 'bold',
            color: theme.palette.primary.main,
            lineHeight: 1.1,
            mb: 0.2,
            textAlign: 'center'
          }}
        >
          {cumulativeTime || '-'}
        </Typography>

        {/* Split time */}
        <Typography
          sx={{
            fontSize: getFontSize(13, 1, isXs, isSm, isMd),
            color: theme.palette.text.secondary,
            lineHeight: 1,
            textAlign: 'center'
          }}
        >
          {splitTime || '-'}
        </Typography>
      </Box>
    </Card>
  );
};

export default LapSplitCard;